import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { approveInvoice, rejectInvoice, viewInvoice } from '../../utils/urls';
import CustomButton from '../../components/common/CustomButton/CustomButton';
import CustomModal from '../../components/common/CustomDialog/CustomModal';
import CustomTextArea from '../../components/common/CustomTextArea';
import FormSubmissionPage from '../Advisors/advisorAuth/FormSubmissionPage';
import axios from 'axios';
import { Toast } from 'flowbite-react';
import { toast } from 'react-toastify';

const InvoicePageDetails = () => {
    const { invoice_display_id } = useParams();
    const invoiceUrl = viewInvoice(invoice_display_id);

    const location = useLocation();
    const invoice_id = location.state?.invoice_id;
    const advisor_invoice_status = location.state?.advisor_invoice_status;

    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [isApproving, setIsApproving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);


    const handleApprove = async () => {
        setIsApproving(true);
        try {
            await axios.put(approveInvoice, {
                invoice_id: invoice_id,
            });
            setIsApproved(true);
            toast.success("Invoice has been successfully approved")
        } catch (error) {
            console.error("Error approving invoice:", error);
            toast.error("Failed to approve the invoice. Please try again later.")
        } finally {
            setIsApproving(false);
        }
    };


    const handleReject = () => {
        setIsRejectModalOpen(true);
    };

    const handleRejectConfirm = async (values, onClose) => {
        setIsRejecting(true);
        try {
            await axios.put(rejectInvoice, {
                invoice_id: invoice_id,
                rejection_reason: values.rejection_reason,
            });
            onClose();
            setIsApproved(true);
            toast.success("Invoice has been rejected successfully.")
        } catch (error) {
            console.error("Error rejecting invoice:", error?.response?.data || error.message);
            toast.error("Failed to reject the invoice. Please try again.")
        } finally {
            setIsRejecting(false);
        }
    };

    if (isApproved) {
        return (
            <FormSubmissionPage
                title={
                    <>
                        Your Invoice Response<br />
                        Has Been Sent
                    </>
                }
                subTitle=""
                path='/invoices'
            />
        );
    }

    return (
        <div className="page-container">
            <div className="my-4">
                <h1 className="text-2xl font-bold text-blue-600">
                    Invoice View ({invoice_display_id})
                </h1>
            </div>

            {invoice_display_id ? (
                <>
                    <div className="w-full h-[90vh] border rounded-md overflow-hidden">
                        <iframe
                            src={invoiceUrl}
                            title="Invoice View"
                            width="100%"
                            height="100%"
                            className="border-none"
                        />
                    </div>

                    {advisor_invoice_status === "Pending" && (
                        <div className="mt-6 flex justify-end gap-4">
                            <CustomButton
                                label="Reject"
                                variant="outlined"
                                size="md"
                                type="button"
                                onClick={handleReject}
                                disabled={isApproving || isRejecting}
                                isLoading={isRejecting}
                            />

                            <CustomButton
                                label="Approve"
                                variant="contained"
                                size="md"
                                type="button"
                                onClick={handleApprove}
                                disabled={isApproving || isRejecting}
                                isLoading={isApproving}
                            />
                        </div>
                    )}
                </>
            ) : (
                <p className="mt-4 text-red-500">Invalid invoice ID.</p>
            )}

            <Formik
                initialValues={{ rejection_reason: '' }}
                validationSchema={Yup.object({
                    rejection_reason: Yup.string()
                        .min(10, 'Minimum 10 characters')
                        .required('Rejection reason is required'),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    handleRejectConfirm(values, () => {
                        setIsRejectModalOpen(false);
                        resetForm();
                        setSubmitting(false);
                    });
                }}
            >
                {({ isSubmitting }) => (
                    <CustomModal
                        open={isRejectModalOpen}
                        title="Rejection Remark"
                        submitLabel="Submit"
                        cancelLabel="Cancel"
                        noTitleWrapper={false}
                        onSubmit={(onClose) => document.getElementById('reject-form').requestSubmit()}
                        onCancel={(onClose) => {
                            setIsRejectModalOpen(false);
                            onClose();
                        }}
                        disabled={isSubmitting}
                    >
                        <Form id="reject-form" className="flex flex-col gap-4 my-4">
                            <CustomTextArea
                                name="rejection_reason"
                                label="Rejection Reason"
                                placeholder="Please provide a reason for rejecting this invoice..."
                                required
                                rows={4}
                            />
                        </Form>
                    </CustomModal>
                )}
            </Formik>
        </div>
    );
};

export default InvoicePageDetails;
